export default "__VITE_ASSET__CMFsudd7__"